<template>
  <div class="interaction-body display-maximum multiple-choice multiple-choice-display-maximum">
    <v-radio-group
      class="pt-0"
      :value="correctAnswer"
      hide-details
    >
      <div
        class="multiple-choice-option mb-1 pa-1 playposit-answer"
        :key="idx"
        v-for="(io, idx) in localInteraction.interactionOptions"
      >
        <v-layout
          align-center
        >
          <v-flex
            :xs11="typeof io.jump === 'number'"
            :xs12="typeof io.jump !== 'number'"
          >
            <v-radio
              class="mb-0"
              :value="io.id"
              :ripple="false"
              readonly
              :color="io.correct ? '#4CAF50' : ''"
            >
              <div
                class="mb-0 pp-interaction-body full-width"
                slot="label"
                v-html="io.option"
              ></div>
            </v-radio>
            <InteractionAttachments :attachments="io.interactionOptionAttachments" />
          </v-flex>
          <v-flex xs1 v-show="typeof io.jump === 'number'">
            <div class="readonly-jump muted">
              <v-icon small>call_split</v-icon>
              <span class="caption">{{$convertTimestamp(io.jump)}}</span>
            </div>
          </v-flex>
        </v-layout>
        <text-box
          v-show="!!io.feedback.length"
          color-key="grey"
          title="Feedback"
          :text="io.feedback"
          :show-text="true"
          tabindex="0"
          :aria-label="`Feedback for answer #${idx + 1}: ${io.feedback && io.feedback.length ? io.feedback.stripHTML(['img', 'Image']) : ''}`"
          :attachments="io.interactionOptionFeedbackAttachments"
          :add-extra-space-above="!io.interactionOptionAttachments.length"
        ></text-box>
      </div>
    </v-radio-group>
  </div>
</template>

<script>
import _ from 'lodash';
import InteractionAttachments from '../../Snippets/InteractionAttachments.vue';
import TextBox from '../../Snippets/TextBox.vue';
import Interaction from '../../../mixins/Interaction';

export default {
  name: 'MultipleChoiceDisplayMaximumInteractionBody',
  components: {
    InteractionAttachments,
    TextBox,
  },
  mixins: [
    Interaction,
  ],
  computed: {
    correctAnswer() {
      return _.get(this.localInteraction.interactionOptions.find((io) => io.correct), 'id', 0);
    },
  },
};
</script>
